import { render, staticRenderFns } from "./CustomDocTypeDocumentExecute.vue?vue&type=template&id=2453c3b6&scoped=true"
import script from "./CustomDocTypeDocumentExecute.vue?vue&type=script&lang=js"
export * from "./CustomDocTypeDocumentExecute.vue?vue&type=script&lang=js"
import style0 from "./CustomDocTypeDocumentExecute.vue?vue&type=style&index=0&id=2453c3b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2453c3b6",
  null
  
)

export default component.exports